import { defineStore } from 'pinia'
import { ref } from 'vue'

/**
 * Outlet yang sedang dipilih (client-state). Daftar outlet-nya server-state
 * (TanStack Query). Composable `useOutletsQuery` yang men-set default ke
 * outlet pertama saat data tiba.
 */
export const useOutletContextStore = defineStore('outlet-context', () => {
  const selectedOutletId = ref<string | null>(null)

  function setOutlet(id: string) {
    selectedOutletId.value = id
  }

  return { selectedOutletId, setOutlet }
})
